import { mapReportParamsToReportTypes } from '@ltvco/refresh-lib/v1';

import type {
  UKAutomobile,
  UKVehicleReport as UKVehicleReportData,
} from '@ltvco/refresh-lib/v2';

export const VEHICLE_MONITOR_REPORT_TYPE =
  mapReportParamsToReportTypes.vehicle ?? '';

const UK_AUTOMOBILE_ARRAY_KEYS = [
  'title_registrations',
  'ownership_history',
  'inspection_events',
  'auctions',
  'liens',
  'thefts',
  'recalls',
] as const;

const isRenderableUKAutomobile = (value: unknown): value is UKAutomobile => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const automobile = value as UKAutomobile;
  return UK_AUTOMOBILE_ARRAY_KEYS.every((key) =>
    Array.isArray(automobile[key])
  );
};

export const isUKVehicleReportData = (
  data: unknown
): data is UKVehicleReportData => {
  if (typeof data !== 'object' || data === null) {
    return false;
  }
  const automobiles = (data as UKVehicleReportData).entities?.vehicles
    ?.automobiles;
  return Array.isArray(automobiles) && isRenderableUKAutomobile(automobiles[0]);
};

export const hasFailedMot = (automobile: UKAutomobile): boolean =>
  automobile.inspection_events.some(
    (event) => event.overall_inspection_result === 'FAILED'
  );

export const hasOutstandingRecalls = (automobile: UKAutomobile): boolean =>
  automobile.recalls.some(
    (recall) =>
      recall.status === null || !recall.status.toLowerCase().startsWith('no ')
  );

export const getUkVehicleHeaderTitle = (automobile: UKAutomobile): string =>
  [automobile.year, automobile.make, automobile.model].join(' ');

export const getUkVehicleSubheaderTitle = (
  automobile: UKAutomobile
): string => {
  const vrm = automobile.vrm;
  const vin = automobile.vin;
  return (
    (typeof vrm === 'string' ? vrm : '') ||
    (typeof vin === 'string' ? vin : '') ||
    ''
  );
};
